module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_2-6524189792326c793c08f7a95f9d8ef9.jpg";